<template>
    <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card color="grey lighten-5">
            <v-flex xs12 sm12>
              <v-toolbar  size="120px" dark color="info">
                <v-toolbar-title >{{dialog_baslik}}</v-toolbar-title>

              </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                <v-layout row="" wrap>
                                        <div class="flex md12">


                      <v-text-field label="Şirket Adı"  :color="color" v-model="Sirket.CompanyName" :error-messages="errors.collect('sirketkod')"
                        v-validate="'required'" data-vv-name="sirketkod" required>
                      </v-text-field>

                    <v-text-field label="Şirket Ünvanı"  :color="color" v-model="Sirket.CompanyTitle" :error-messages="errors.collect('sirketadi')"
                      v-validate="'required'" data-vv-name="sirketadi" required>
                    </v-text-field>
                </div>

                </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-show="m === true">
                <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
                <v-btn id="bsil" color="blue darken-1" flat @click="deletesirket()">Sİl</v-btn>
              </div>

              <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
              <div v-show="k === true">
                <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout row wrap>
        <v-toolbar  dark color="info">
          <v-toolbar-title class="baslikfont">Şirket Tanımlama</v-toolbar-title>
          <v-spacer></v-spacer>
           <v-spacer></v-spacer>
 <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
          <v-btn hidden="xs" flat @click="sirketekle()"> Şirket Ekle
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </v-toolbar>
      </v-layout>

      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-data-table :headers="headers" :rows-per-page-items=[50,100]  :loading="progress" :items="items" :search="search3">
          <v-progress-linear slot="progress"   indeterminate></v-progress-linear>

          <template slot="items" slot-scope="props">
            <tr @click="Getir(props.item)" item>
              <td class="text-xs-left">{{ props.item.SirketKodu }}</td>
              <td class="text-xs-left">{{ props.item.SirketAdi }}</td>
              <td class="text-xs-left">{{ props.item.SirketUnvani }}</td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
          </v-alert>
        </v-data-table>
      </v-card>

      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
        <v-dialog v-model="dialog1" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Uyarı !</v-card-title>
            <v-card-text>{{dialogmessage1}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click.native="dialog1=false">Tamam</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </template>
    </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Şirket Kodu',
            value: 'SirketKodu'
          },
          {
            text: 'Şirket Adı ',
            value: 'SirketAdi'
          },
          {
            text: 'Sirket Ünvanı',
            value: 'SirketUnvani'
          }


        ],
        loading: false,
        color: 'orange darken-4',
        yedeksirket: [],
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        dialog1: false,
        dialogmessage1: '',
        Sirket: {
          CompanyCode: '',
          CompanyName: '',
          CompanyTitle: ''
        },
        state: [],
        yenisirket: {
          id: '',
          text: '',
          unvan: ''
        },
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            sirketkod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            sirketadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.$validator.reset()

        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Şirket Güncelle'

this.Sirket.CompanyCode = v.SirketKodu
          this.Sirket.CompanyName = v.SirketAdi
          this.Sirket.CompanyTitle = v.SirketUnvani


      },
      deletesirket: deletesirket,
      sirketekle: sirketekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
  }



  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu,
          CompanyName: this.Sirket.CompanyName,
          CompanyTitle: this.Sirket.CompanyTitle
        }
        this.$http.post(auth.API_URL + 'api/Company/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.dialog = false

          this.yenisirket.id = response.body.SirketKodu
          this.yenisirket.text = response.body.SirketAdi,
            this.yenisirket.unvan = response.body.SirketUnvani

          var yedeksirket = credentials.Sirketler;
          credentials.Sirketler = [];

          for (let index = 0; index < yedeksirket.length; index++) {
            const element = yedeksirket[index];
            credentials.Sirketler.push(element)
          }
          credentials.Sirketler.push(this.yenisirket);

          window.localStorage.setItem('credentials', JSON.stringify(credentials))

          location.reload();


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          }
        })
      }
    })

  }

  function sirketekle() {

    this.dialog = true
    this.Sirket = {}
    this.dialog_baslik = 'Şirket Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu,
    }
    this.progress = true
    this.$http.post(auth.API_URL + 'api/Company/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })
  }

  function deletesirket() {

    if (window.confirm('Şirket\'i silmek istediğinizden eminmisiniz?')) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      if (credentials.SirketKodu != this.Sirket.CompanyCode) {
        var params = this.Sirket
        var silinensirket = this.Sirket.CompanyCode
        this.$http.post(auth.API_URL + '/api/Company/Delete', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true

            //sirketleri güncelleyelim.
            var yedeksirket = []
            yedeksirket = credentials.Sirketler
            credentials.Sirketler = []

            for (let index = 0; index < yedeksirket.length; index++) {
              if (yedeksirket[index].id != silinensirket) {
                const element = yedeksirket[index];
                credentials.Sirketler.push(element)
              }
              window.localStorage.setItem('credentials', JSON.stringify(credentials));
            }

            location.reload();
            var params1 = {
              CompanyCode: credentials.SirketKodu,
            }

            this.$http.post(auth.API_URL + 'api/Company/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }


            }).then((response) => {
              this.items = response.body
              this.dialog = false

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-List'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-List'
                this.snackbar = true
              }
            })

          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })

      } else {
        this.dialogmessage1 =
          'Silmek istediğiniz şirket şuan aktif olan şirkettir, lütfen şirket değişikliği yaptıktan sonra tekrar deneyiniz.'
        this.dialog1 = true

      }

    }


  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        if (credentials.SirketKodu != this.Sirket.CompanyCode) {
          var params = this.Sirket
          this.codegorunum = false
          this.$http.post(auth.API_URL + 'api/Company/Update', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            if (response.body.Status) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
              this.yenisirket.id = this.Sirket.CompanyCode
              this.yenisirket.text = this.Sirket.CompanyName
              this.yenisirket.unvan = this.Sirket.CompanyTitle

              var yedeksirket = credentials.Sirketler;
              credentials.Sirketler = [];

              for (let index = 0; index < yedeksirket.length; index++) {
                const element = yedeksirket[index];
                if (this.yenisirket.id != yedeksirket[index].id) {
                  credentials.Sirketler.push(element)
                } else {
                  credentials.Sirketler.push(this.yenisirket);
                }
              }
              window.localStorage.setItem('credentials', JSON.stringify(credentials))
              location.reload();
            } else {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })

        } else {
          this.dialogmessage1 =
            'Güncellemek istediğiniz şirket şuan aktif olan şirkettir, lütfen şirket değişikliği yaptıktan sonra tekrar deneyiniz.'
          this.dialog1 = true
        }

      }
    })
  }
</script>

<style>
</style>